import React from 'react';
import styled from 'styled-components';
import Label from './Label';

interface Props {
    label: string;
    tooltip?: string;
    value: any;
}

const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`;

const LabelContainer = styled.div``;

const TooltipWrapper = styled.div`
    width: max-content;
`;

const ValueContainer = styled.div`
    text-align: right;
    font-size: 16px;
    margin-bottom: 16px;
`;

export const Value: React.FC<Props> = ({ label, tooltip, value }: Props) => {
    return (
        <Container>
            <LabelContainer>
                {tooltip ? (
                    <TooltipWrapper>
                        <Label label={label} tooltip={tooltip} />
                    </TooltipWrapper>
                ) : (
                    <Label label={label} tooltip={tooltip} />
                )}
            </LabelContainer>
            <ValueContainer>{value}</ValueContainer>
        </Container>
    );
};

export default Value;
